// Nav routing helpers (Batch B2, 2026-08-18).
//
// Extracted from Nav.jsx as a small testable unit so the 100% frontend
// diff-coverage gate can line-cover the routing + active-detection branches.
// The Nav.jsx JSX wiring itself is host-shell (coverage-excluded); the
// decision logic lives here where it can be unit-tested.
//
// A nav item may carry an explicit `route` (destination path) and/or a
// `matchPrefix` (pathname prefix that marks it active). When both are absent,
// the legacy convention holds: the route is `/${id}` and the item is active
// when `location.pathname.replace("/", "")` equals the id. This mirrors the
// exact behavior Nav.jsx had before B2, so existing tabs are untouched.

// Route the sidebar should navigate to when a nav item is clicked.
export function navRouteFor(item) {
  if (item.route) {
    return item.route;
  }
  return `/${item.id}`;
}

// Whether a nav item should render in its active (highlighted) state for the
// current pathname.
export function isNavItemActive(item, pathname) {
  if (item.matchPrefix) {
    return pathname.startsWith(item.matchPrefix);
  }
  const activeTab = pathname.replace("/", "") || "library";
  return activeTab === item.id;
}
